export enum ServiceType {
    php = 'php',
    external = 'external',
}

export const SERVICE_ALL = '__all'
